import { isEqual } from 'lodash';
import React, { useContext, useEffect } from 'react';
import { useStepper } from '../common/components/StepperContext';
import { FormContext } from '../common/form/FormContext';
import FormModalInfoAlert from '../common/form/FormModalInfoAlert';
import ProductionFormModal from '../production/form/CreateProductionFormModal';
import { ProductionFormModalType, Production_Field_Names } from '../production/helpers/productionUtils';

export default (props: ProductionFormModalType) => {
    const { getStepData, setStepCompletion, setStepData, activeStep } = useStepper();
    const { state, validation } = useContext(FormContext);
    const currentData = getStepData(activeStep);

    useEffect(() => {
        setStepCompletion(activeStep, validation?.isValid);
    }, [activeStep, setStepCompletion, validation?.isValid]);

    useEffect(() => {
        // Save to stepper storage whenever state changes
        if (!isEqual(currentData, state)) {
            setStepData(activeStep, state);
        }
    }, [activeStep, currentData, setStepData, state]);

    const keysToHide = [
        'productionStatus',
        'locations',
        'scheduleSection',
        'productionTrack',
        'sectionTitle',
        'productionGroup.productionReference',
        'showAttributes',
        'budget.currencyCode',
        'budget'
    ];
    const hiddenFields = keysToHide.reduce(
        (acc, key) => {
            if (Production_Field_Names[key]) {
                acc[Production_Field_Names[key]] = true;
            }
            return acc;
        },
        {} as Record<string, boolean>
    );

    return (
        <>
            <FormModalInfoAlert
                title="stepper.hiring.production.info.title"
                descriptionToken={'stepper.hiring.production.info.description'}
            />
            <ProductionFormModal {...props} hiddenFields={hiddenFields} />
        </>
    );
};
